import { render, staticRenderFns } from "./HomeContent.vue?vue&type=template&id=154243d6&scoped=true&"
import script from "./HomeContent.vue?vue&type=script&lang=js&"
export * from "./HomeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154243d6",
  null
  
)

export default component.exports